import { TNotification } from '@/contexts/notificationsContext/domain/types';
import { isString } from '@/utils';

const getActionPath = (
  pathTemplate: string | ((data: TNotification['payload']) => string), notification: TNotification | { payload: Record<string, string> },
) => {
  if (isString(pathTemplate)) return pathTemplate;
  return pathTemplate(notification.payload);
};

export default getActionPath;
